<template>
    <div class="tInfo">
        <h2><span class="el-icon-d-arrow-left" @click="back()"></span>UDP Relay Info</h2>
        <div class="searchBox">
            <span class="title">Peer_ID:</span>
            <el-input class="IdInput" v-model="serchTId" @keyup.native="serchTId=serchTId.replace(/\s+/g,'')" placeholder="Input Peer Id" maxlength="16"></el-input>
            <el-button class="searchBth" :disabled="loading" @click="searchApi('')">Search</el-button>
        </div>
        <div class="infoList"
             v-loading="loading"
             element-loading-text="Loading..."
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <el-table
                    v-if='tableData.length>0'
                    :data="tableData"
                    style="width: 100%"
                    empty-text="  "
            >
                <el-table-column
                        prop="xmlContext"
                        label="XMLContext"
                        align="center"
                        width="650">
                    <template slot-scope="scope" >
                        <div class="xml" v-for="(item,index) in scope.row.contentList" :key="index">{{item}}<br></div>
                    </template> 
                </el-table-column>

                <el-table-column
                        prop="timestamp"
                        label="TimeStamp"
                        align="center"
                        width="270">
                    <template slot-scope="scope">
                        {{(new Date(parseInt(scope.row.timestamp*1000))).toUTCString()}}
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                    v-if='tableData.length>0'
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :pageSizes="[15]"
                    :pageSize="15"
                    :total="total"
                    layout="total,prev, pageF, next, pageL,nowSize, jumper"
            />
        </div>

    </div>
</template>

<script>
    import Pagination from './common/Pagination';

    export default {
        name: 'UdpRelayInfo',
        props: {
            msg: String
        },
        components: {
            Pagination
        },
        data() {
            return {
                serchTId: '',
                startTime: new Date(),
                endTime: new Date(),
                params: {
                    peerId: '',
                    pageNumber: 1,
                    numEveryPage: 15
                },
                tableData: [],
                total: 1,
                pageNum: 1,
                dialogVisible:false,
                xmlHtml:[],
                loading:false
            }
        },
        mounted() {
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            searchApi(page) {
                if (page == ''){
                    this.pageNum = 1;
                    this.params.pageNumber = 1;
                }
                this.params.peerId = this.serchTId.trim();
                if (this.params.peerId == "" || this.params.peerId.length != 16) {
                    this.$message({
                        message: 'Please check the Peer_ID length being 16 in HEX.',
                        type: 'warning'
                    });
                    return;
                }
                this.loading = true
                this.axios.post('/tp/web/ajaxRelayServlet/updRelayInfo', this.params).then(res => {
                    this.loading = false
                    // console.log(res.data.result);
                    this.total = res.data.result.total;
                    this.pageNum = res.data.result.pageNum;
                    this.tableData = res.data.result.list;
                    if (this.tableData.length == 0){
                        this.$message({
                            message: 'Not found list',
                        });
                    }

                    this.tableData.map(v =>{
                        // v.timestamp = this.handlerDate(v.timestamp)
                        let temp = (v.xmlContext).replace(/>/g,'>@');
                        Object.assign(v,{'contentList':temp.split('@')});
                    })

                }).catch(error => {
                    this.loading = false
                    console.log(error);
                })
                // console.log(this.tranfromTime(this.startTime), this.tranfromTime(this.endTime));
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.params.pageNumber = val;
                this.params.numEveryPage = 15;
                this.searchApi('page');
            },
            goToDevice(i) {
                // console.log(i);
                this.dialogVisible = true;
                this.xmlHtml = i.xmlContext
            },
            //handlerDate(date)
            handlerDate(date) {
                let oDate = new Date(date);
                if (oDate == "") {
                    return;
                } else {
                    let str = new Date(date).toUTCString()
                    return str;
                }
            },
            // add 0 when data < 9
            add0(data) {
                return data > 9 ? data : ("0" + data);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .tInfo {
        width: 1024px;
        max-width: 1024px;
        border: 0 solid gray;
        margin-top: -22px;
        margin-left: auto;
        margin-right: auto;
        background-color: #151515;
        /*min-height: 100px;*/
        /deep/.el-dialog{
            min-height: 200px;
            max-height: 800px;
            overflow: hidden;
            overflow-y: auto;
        }

        h2 {
            span {
                padding-right: 15px;
                cursor: pointer;
            }

            color: #fff;
            font-size: 24px;
        }

        .searchBox {

            padding:10px 30px;
            height: 30px;

            .title {
                
                color: #ffffff;
                line-height: 30px;
                padding: 0 10px;
            }

            .IdInput {
                width: 173px;
                

                /deep/ .el-input__inner {
                    height: 30px;
                }
            }

            .timeInput {
                width: 195px;
               

                /deep/ .el-input__inner {
                    height: 30px;
                }

                /deep/ .el-input__icon {
                    line-height: 30px;
                }
            }

            .searchBth {
                height: 30px;
                line-height: 5px;
                
                margin-left: 10px;
            }
        }

        .infoList {
            padding-left: 30px;
            min-height: 50px;
            /*/deep/.el-table{*/
            /*    background: #151515;*/
            /*    /deep/.el-table thead{*/
            /*        background-color: #151515;*/
            /*    }*/
            /*}*/
            /deep/ .el-table--border::after, .el-table--group::after, .el-table::before {
                background-color: #151515;
            }

            /deep/ .el-table {
                background: #151515;
                color: #fff;
                margin-top: 15px;
                font-size: 16px;
                font-weight: 400;
                .el-table__header-wrapper {
                    .has-gutter {
                        tr, th {
                            background: #33cc66;
                            border-bottom: 2px solid #33cc66;
                            color: #ffffff;
                            font-weight: 100;
                        }
                    }
                }

                .el-table_row td, .el-table_row th {
                    height: 50px;
                    line-height: 50px;
                    box-sizing: border-box;
                    padding: 0;

                    .cell {
                        line-height: 50px;
                        height: 50px;
                        
                    }
                }

                td .cell .xml{
                    text-align: left;
                    word-break: normal;
                }

                .el-table-row, tr {
                    background: #151515;

                    td {
                        border-bottom: 1px solid #333;
                    }
                }

                .iconBox {
                    margin-bottom: 0;
                    display: none;
                }

                tr:hover {
                    .iconBox {
                        display: block;
                    }
                }

                tr:hover > td {
                    background: none !important;
                }
            }
        }
    }
</style>
